export const NONE = "NONE";

export function doNothingAction() {
    return {
        type: NONE,
    };
}
